import { SproutIcon } from './SproutIcon';

/**
 * author: Michael Irigoyen
 * id 58F40CA4-567A-42EF-A5D9-DD6A1BB42437
 * name sprout
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sprout.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const EcologyIcon = SproutIcon;
export default EcologyIcon